import MainModuleFactory from "@imi-ernd-be/hyselect-engine";

export const engine = await MainModuleFactory();

// Ideally this should be provided by a context but currently the engine is not capable of clearing the DB, thus in
// dev+strict mode we initialize it twice, which cause issues.
export const hySelectEngine = new engine.HySelectEngine();
hySelectEngine.initEngine();
